import pie from "pistacja/plugin";
import revealContent from "reveal-content";
import usppModal from "pistacja/uspp-modal";

pie.plugin(({ $, domain }) => {
  const toggleFilters = $("#toggle-filters");
  const filtersSummary = $("#filters-summary");
  const filtersOptions = $("#filters-options");

  toggleFilters?.addEventListener("click", () => {
    filtersSummary.classList.toggle("active");
    filtersOptions.classList.toggle("active");
  });

  // USPP modal.
  usppModal("#usppModal", domain);

  // Search results overflow tooltip.
  revealContent({
    displayHeight: 48,
    resetOnResize: true,
    targetClass: ".pie-result-item-description",
  });
});
